import {useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import {FETCH_BANNER} from "../../redux/actions";

const Banner = () => {


    const dispatch = useDispatch();
    const { bannerData} = useSelector((state) => state.bannerData);
    const selectedId = useSelector((state) => state.selectItemDrawerMenu.selectedId);
    const loading = useSelector((state) => state.loading);

    useEffect(() => {
        // if (selectedId) {
        dispatch({type:FETCH_BANNER});
        // }
    }, [dispatch , selectedId]);


    return (
        <div style={{width:'100%',display: 'flex', flexDirection: 'column' , alignItems:'center'}}>
            {
                !loading ?
                bannerData?.map(
                    item =>
                        <a href={item?.url} style={{width: '100%', height: '180px', marginBottom: '20px'}}>
                            <div className='banner' style={{width: '100%', height: '180px'}}>
                                <img src={`${item?.path}`} alt={`${item?.alt}`}
                                     style={{width: '100%', height: '180px', borderRadius: '8px'}}/>
                            </div>
                        </a>
                )
                    :
                    <p style={{color:'white'}}>loading...</p>
            }
        </div>
    )
}

export default Banner
